// src/ConfigurationProvider.ts
function isStringValue(value) {
  return typeof value === "string" && value !== "";
}
function isArrayValue(value) {
  return Array.isArray(value) && value.every(_ => typeof _ === "string" && _ !== "");
}
function isBooleanValue(value) {
  return typeof value === "boolean";
}
var ConfigurationProvider = class {
  constructor() {
    this.values = {};
  }
  provideValues(values) {
    Object.assign(this.values, values);
  }
  getValue(key) {
    if (isStringValue(this.values[key])) {
      return this.values[key];
    }
    throw new Error("Missing configuration value or other type than 'string': ".concat(key));
  }
  getValueAsArray(key) {
    if (isArrayValue(this.values[key])) {
      return this.values[key];
    }
    throw new Error("Missing configuration value or other type than 'string[]': ".concat(key));
  }
  getValueAsBoolean(key) {
    if (isBooleanValue(this.values[key])) {
      return this.values[key];
    }
    throw new Error("Missing configuration value or other type than 'boolean': ".concat(key));
  }
};
var configurationProvider = new ConfigurationProvider();
var ConfigurationProvider_default = configurationProvider;

// src/ImplementationProvider.ts
var ImplementationProvider = class {
  provideSentryHelper(sentryHelper) {
    this.sentryHelperImplementation = sentryHelper;
  }
  provideCustomerCareComponent(customerCareComponent) {
    this.customerCareComponentImplementation = customerCareComponent;
  }
  get sentryHelper() {
    if (typeof this.sentryHelperImplementation === "undefined") {
      throw new Error("No SentryHelper implementation provided.");
    }
    return this.sentryHelperImplementation;
  }
  get customerCareComponent() {
    if (typeof this.customerCareComponentImplementation === "undefined") {
      throw new Error("No CustomerCareComponent implementation provided.");
    }
    return this.customerCareComponentImplementation;
  }
};
var implementationProvider = new ImplementationProvider();
var ImplementationProvider_default = implementationProvider;
export { ConfigurationProvider_default as configurationProvider, ImplementationProvider_default as implementationProvider };